import React from 'react';
import './ImpersonationBanner.css';

const KEY_TOKEN = 'admin_return_access_token';
const KEY_REFRESH = 'admin_return_refresh_token';
const KEY_EMAIL = 'admin_return_email';

export function startImpersonation(accessToken: string, targetEmail: string) {
  const currentAccess = localStorage.getItem('access_token');
  const currentRefresh = localStorage.getItem('refresh_token');
  if (currentAccess) sessionStorage.setItem(KEY_TOKEN, currentAccess);
  if (currentRefresh) sessionStorage.setItem(KEY_REFRESH, currentRefresh);
  sessionStorage.setItem(KEY_EMAIL, targetEmail);
  localStorage.setItem('access_token', accessToken);
  localStorage.removeItem('refresh_token');
  window.location.href = '/';
}

export default function ImpersonationBanner() {
  const adminToken = sessionStorage.getItem(KEY_TOKEN);
  const viewingEmail = sessionStorage.getItem(KEY_EMAIL);
  if (!adminToken) return null;

  const returnToAdmin = () => {
    localStorage.setItem('access_token', adminToken);
    const adminRefresh = sessionStorage.getItem(KEY_REFRESH);
    if (adminRefresh) localStorage.setItem('refresh_token', adminRefresh);
    sessionStorage.removeItem(KEY_TOKEN);
    sessionStorage.removeItem(KEY_REFRESH);
    sessionStorage.removeItem(KEY_EMAIL);
    window.location.href = '/admin';
  };

  return (
    <div className="impersonation-banner">
      <span>Podgląd konta: <strong>{viewingEmail}</strong></span>
      <button onClick={returnToAdmin}>Wróć do panelu admina</button>
    </div>
  );
}
